import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { format, parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { useHistory } from 'react-router-dom';
import Header from '../../components/Header';
import StandardContainer from '../../components/StandardContainer';
import TableNews from '../../components/Table';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import { Content } from './styles';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '../../components/Select';
import { useLocation } from 'react-router-dom';
import Button from '../../components/Button';

interface Data {
  id: string;
  code: number;
  question: string;
  alternative1: string;
  alternativeCorrect1: string;
  alternative2: string;
  alternativeCorrect2: string;
  alternative3: string;
  alternativeCorrect3: string;
  alternative4: string;
  alternativeCorrect4: string;
  difficultyLevel: string;
  type: string;
  game: string;
}

interface IQuizGameBible {
  id: number;
  question: string;
  alternative1: string;
  alternative1_correct: string;
  alternative2: string;
  alternative2_correct: string;
  alternative3: string;
  alternative3_correct: string;
  alternative4: string;
  alternative4_correct: string;
  difficulty_level: string;
  type: string;
  game: string;
}

function createData(
  id: string,
  code: number,
  question: string,
  alternative1: string,
  alternativeCorrect1: string,
  alternative2: string,
  alternativeCorrect2: string,
  alternative3: string,
  alternativeCorrect3: string,
  alternative4: string,
  alternativeCorrect4: string,
  difficultyLevel: string,
  type: string,
  game: string,
): Data {
  return {
    id,
    code,
    question,
    alternative1,
    alternativeCorrect1,
    alternative2,
    alternativeCorrect2,
    alternative3,
    alternativeCorrect3,
    alternative4,
    alternativeCorrect4,
    difficultyLevel,
    type,
    game,
  };
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

const headCells: HeadCell[] = [
  { id: 'code', numeric: true, disablePadding: true, label: 'ID' },
  {
    id: 'question',
    numeric: false,
    disablePadding: false,
    label: 'Questão',
  },
  {
    id: 'alternative1',
    numeric: false,
    disablePadding: false,
    label: 'Alternativa 1',
  },
  {
    id: 'alternativeCorrect1',
    numeric: false,
    disablePadding: false,
    label: 'Alternativa 1 Correta',
  },
  {
    id: 'alternative2',
    numeric: false,
    disablePadding: false,
    label: 'Alternativa 2',
  },
  {
    id: 'alternativeCorrect2',
    numeric: false,
    disablePadding: false,
    label: 'Alternativa 2 Correta',
  },
  {
    id: 'alternative3',
    numeric: false,
    disablePadding: false,
    label: 'Alternativa 3',
  },
  {
    id: 'alternativeCorrect3',
    numeric: false,
    disablePadding: false,
    label: 'Alternativa 3 Correta',
  },
  {
    id: 'alternative4',
    numeric: false,
    disablePadding: false,
    label: 'Alternativa 4',
  },
  {
    id: 'alternativeCorrect4',
    numeric: false,
    disablePadding: false,
    label: 'Alternativa 4 Correta',
  },
  {
    id: 'difficultyLevel',
    numeric: false,
    disablePadding: false,
    label: 'Dificuldade',
  },
  { id: 'type', numeric: false, disablePadding: false, label: 'Tipo' },
  { id: 'game', numeric: false, disablePadding: false, label: 'Game' },
];

interface IParams {
  state: {
    game: string;
  };
}

const GameBible = () => {
  const { state }: { state: IParams } = useLocation();
  const [rows, setRows] = useState<IQuizGameBible[]>([]);
  const [loading, setLoading] = useState(true);
  const [deleted, setDeleted] = useState(false);
  const formRef = useRef<FormHandles>(null);

  const { addToast } = useToast();

  const history = useHistory();

  const [gameType, setGameType] = useState<{ label: string; value: string }[]>([
    { value: 'game_web', label: 'Game Web' },
    { value: 'game_family_devotees', label: 'Game Família Devotos' },
    { value: 'all', label: 'Todos' },
  ]);

  // useEffect(() => {
  //   api.get('/game-bible/', { params: { limit: 10000 } }).then(response => {
  //     setRows(response.data);
  //     console.log(response.data, 'dados');
  //     setLoading(false);
  //   });
  // }, [deleted]);

  const onDelete = useCallback(
    id => {
      api.delete(`/game-bible/${id}`).then(response => {
        setDeleted(!deleted);
        addToast({
          type: 'success',
          title: 'Pergunta deletada com sucesso!',
        });
      });
    },
    [setDeleted, deleted, addToast],
  );

  const newsRows = useMemo(() => {
    return rows.map(row =>
      createData(
        row.id.toString(),
        row.id,
        row.question,
        row.alternative1,
        row.alternative1_correct,
        row.alternative2,
        row.alternative2_correct,
        row.alternative3,
        row.alternative3_correct,
        row.alternative4,
        row.alternative4_correct,
        row.difficulty_level,
        row.type,
        row.game,
      ),
    );
  }, [rows]);

  const onCreate = useCallback(() => {
    history.push('/bible-game/question/create');
  }, [history]);

  const onEdit = useCallback(
    row => {
      history.push('/bible-game/:id', { id: row.code });
    },
    [history],
  );

  useEffect(() => {
    getRows()
  }, [deleted])

  const getRows = useCallback(
    async (game = 'all') => {
      setLoading(true);
      try {
        console.log(`Carregando dados para o filtro: ${game}`);
        const response = await api.get(`/game-bible/filter-questions-by-game/${game}`);
        setRows(response.data);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
        addToast({
          type: 'error',
          title: 'Erro ao buscar dados',
          description: 'Ocorreu um erro ao buscar as perguntas.',
        });
      }
      setLoading(false);
    },
    [addToast],
  );

  useEffect(() => {
    console.log('DADOS', rows)
  }, [rows])

  const tableBodyCells = useCallback(
    (isItemSelected, labelId, row) => (
      <>
        <TableCell padding="checkbox">
          <Checkbox
            checked={isItemSelected}
            inputProps={{ 'aria-labelledby': labelId }}
          />
        </TableCell>
        <TableCell component="th" id={labelId} scope="row" padding="none">
          {row.id}
        </TableCell>
        <TableCell align="left">{row.question}</TableCell>
        <TableCell align="left">{row.alternative1}</TableCell>
        <TableCell align="left">{row.alternativeCorrect1}</TableCell>
        <TableCell align="left">{row.alternative2}</TableCell>
        <TableCell align="left">{row.alternativeCorrect2}</TableCell>
        <TableCell align="left">{row.alternative3}</TableCell>
        <TableCell align="left">{row.alternativeCorrect3}</TableCell>
        <TableCell align="left">{row.alternative4}</TableCell>
        <TableCell align="left">{row.alternativeCorrect4}</TableCell>
        <TableCell align="left">{row.difficultyLevel}</TableCell>
        <TableCell align="left">{row.type}</TableCell>
        <TableCell align="left">{row.game}</TableCell>
      </>
    ),
    [],
  );

  useEffect(() => {
    getRows('all');
  }, [getRows]);

  const handleSubmitFilter = async (event: React.FormEvent) => {
    const data = formRef.current?.getData();
    const selectedGame = data?.game;

    console.log('Filtro acionado com valor:', selectedGame);

    if (!selectedGame) {
      addToast({
        type: 'error',
        title: 'Valores inválidos',
        description: 'Selecione um game para filtrar',
      });
      return;
    }

    getRows(selectedGame);
  };

  return (
    <StandardContainer>
      <Header />
      <Content>
        <Form
          ref={formRef}
          onSubmit={handleSubmitFilter}
          style={{
            flexDirection: 'row',
            display: 'flex',
            width: '100%',
            alignItems: 'flex-end',
            marginBottom: 20,
          }}
        >
          <div>
            <div>
              <Select
                name="game"
                label="Selecione o Game"
                defaultOption={state?.state.game || 'all'}
                options={gameType}
                // onChange={handleSelectedGame}
                style={{ width: '400px', marginRight: '18px' }}
              />
            </div>
            <div>
              <Button
                type="submit"
                loading={loading}
                style={{ width: 200, marginLeft: 10 }}
              >
                Filtrar
              </Button>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginTop: '25px',
                }}
              ></div>
            </div>
          </div>
        </Form>
        <TableNews<Data, HeadCell[]>
          title="Game Web e Game Família dos Devotos"
          headCells={headCells}
          rows={newsRows}
          orderByDefaultColumn="updated_at"
          defineOrder="desc"
          onCreate={onCreate}
          onDelete={onDelete}
          onEdit={onEdit}
          tableBodyCells={tableBodyCells}
          loading={loading}
        />
      </Content>
    </StandardContainer>
  );
};

export default GameBible;
